import {
  InternalNavigationScreen,
  InternalNavigationScreens,
} from 'features/entities/entitiesTypes';

type ScreenToRoutesMap = {
  [key in InternalNavigationScreen]: string;
};

type RoutesToScreenMap = {
  [key: string]: (typeof InternalNavigationScreens)[InternalNavigationScreen];
};

export const screenToRoutesMap: ScreenToRoutesMap = {
  [InternalNavigationScreens.CONTACT_SCREEN]: '/contact',
  [InternalNavigationScreens.DOMICILE_SELECTION_SCREEN]: '',
  [InternalNavigationScreens.HOME_SCREEN]: '/home',
  [InternalNavigationScreens.INSIGHTS_SCREEN]: '/insights',
  [InternalNavigationScreens.ONBOARDING_SCREEN]: '/welcome',
  [InternalNavigationScreens.T_AND_C_SCREEN]: '',
  [InternalNavigationScreens.LANDING_SCREEN]: '',
  [InternalNavigationScreens.MIGRATION_START_SCREEN]: '/migrationStart',
  [InternalNavigationScreens.MIGRATION_INTERIM_SCREEN]: '/migrationInterim',
  [InternalNavigationScreens.MIGRATION_ERROR_SCREEN]: '/migrationError',
};

export const routesToScreenMap: RoutesToScreenMap = {
  '/contact': InternalNavigationScreens.CONTACT_SCREEN,
  '/home': InternalNavigationScreens.HOME_SCREEN,
  '/insights': InternalNavigationScreens.INSIGHTS_SCREEN,
  '/welcome': InternalNavigationScreens.ONBOARDING_SCREEN,
  '/migrationStart': InternalNavigationScreens.MIGRATION_START_SCREEN,
  '/migrationInterim': InternalNavigationScreens.MIGRATION_INTERIM_SCREEN,
  '/migrationError': InternalNavigationScreens.MIGRATION_ERROR_SCREEN,
};
